import axios from 'axios' 
import ElementUI from 'element-ui';
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){
    return new Promise((resolve, reject) =>{	
        axios.get(url, {
            params: params
        }).then(res => {
			if(res.data.code == 403) {
				ElementUI.Message({
					message: 'token失效，请重新登录',
					type: 'error'
				});
				window.location.href = '/'
				localStorage.clear();
				return false
			}
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)
    	})
	});
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
         axios.post(url, params)
        .then(res => {
			if(res.data.code == 403) {
				ElementUI.Message({
					message: 'token失效，请重新登录',
					type: 'error'
				});
				window.location.href = '/'
				localStorage.clear();
				return false
			}
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
return new Promise((resolve,reject) => {
	axios.patch(url,data)
		.then(response => {
			if(response.data.code == 403) {
				ElementUI.Message({
					message: 'token失效，请重新登录',
					type: 'error'
				});
				window.location.href = '/'
				localStorage.clear();
				return false
			}
			resolve(response.data);
		},err => {
			reject(err)
		})
})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
return new Promise((resolve,reject) => {
	axios.put(url,data)
		.then(res => {
			if(res.data.code == 403) {
				ElementUI.Message({
					message: 'token失效，请重新登录',
					type: 'error'
				});
				window.location.href = '/'
				localStorage.clear();
				return false
			}
			resolve(res.data);
		},err => {
			reject(err)
		})
})
}

/**
 * 封装deleFn请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function deleteFn(url, params) {
	return new Promise((resolve, reject) => {
		axios.delete(url, params)
			.then(res => {
				if(res.data.code == 403) {
					ElementUI.Message({
						message: 'token失效，请重新登录',
						type: 'error'
					});
					window.location.href = '/'
					localStorage.clear();
					return false
				}
				resolve(res.data);
			})
			.catch(err =>{
				reject(err.data)
			})
	});
}
/*****时间转化 */
export function formatDate (date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	}
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + ''
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
		}
	}
	return fmt
}
function padLeftZero (str) {
	return ('00' + str).substr(str.length)
}

export default {
	get,
	post,
	patch,
	put,
	deleteFn,
	formatDate
}


// WEBPACK FOOTER //
// ./src/api/index.js